import request from '@/utils/request'

// 物品类型列表
export function GetLostFindTypeList(){
  return request({
    url: 'lost-found/item-type',
    method: 'get'
  })
}

// 获取等待认领和寻找失物列表
export function GetLostFindList(params){
  return request({
    url: 'lost-found',
    method: 'get',
    params
  })
}

// 获取详情
export function GetLostFindDetail(params){
  return request({
    url: 'lost-found/' + params.id,
    method: 'get'
  })
}

//获取自己提交的失物/拾物
export function GetMineLostFindList(params){
  return request({
    url: 'lost-found/me',
    method: 'get',
    params
  })
}

//拾物/失物确认
export function PostConfirmThing(data){
  return request({
    url: 'lost-found/confirm/' + data.id,
    method: 'post',
    data
  })
}

// 认领拾物
export function PostClaimThing(data){
  return request({
    url: 'lost-found/claim/' + data.id,
    method: 'post',
    data
  })
}

// 标签列表
export function GetTabList(params){
  return request({
    url: 'lost-found/label',
    method: 'get',
    params
  })
}

// 校区列表
export function GetSchoolList(){
  return request({
    url: 'lost-found/campus',
    method: 'get'
  })
}


// 新增失物
export function PostLostFound(data){
  return request({
    url: 'lost-found',
    method: 'post',
    data
  })
}

// 图片上传
export function PostLostFoundImage(data){
  return request({
    url: 'lost-found/image/upload',
    method: 'post',
    timeout: 300000,
    data
  })
}

// 获取推荐
export function GetLostFoundRecommend(params){
  return request({
    url: 'lost-found/recommend',
    method: 'get',
    params
  })
}

// 删除失物/拾物
export function DeleteLostFoundItem(data){
  return request({
    url: 'lost-found/'+data.id,
    method: 'delete',
    data
  })
}

//修改失物/拾物
export function PutLostFound(data){
  return request({
    url: 'lost-found/' + data.id,
    method: 'put',
    data
  })
}

// 检查学号
export function GetCheckNumber(params){
  return request({
    url: 'lost-found/card-number',
    method: 'get',
    params
  })
}

// 拾取物品（我捡到了）
export function PostFound(data){
  return request({
    url: 'lost-found/found/'+data.id,
    method: 'post'
  })
}

// 是否引导过
export function GetGuideStatus(){
  return request({
    url: 'lost-found/guide',
    method: 'get'
  })
}

// 修改引导状态
export function PostGuideStatus(){
  return request({
    url: 'lost-found/has-guide',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/LostFind.js


// WEBPACK FOOTER //
// ./src/api/LostFind.js